export default __webpack_public_path__ + "static/media/zip.09173a79.svg";